import { useState, useEffect } from "react";
import Layout from "../components/Layout/Layout";
import privateGroupImage from "../assets/private-group-training.jpg";
import axios from "axios";

const PrivateGroupTraining = () => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [contentDetail, setContentDetail] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", formData);
    setSubmitted(true);
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/private-group-training`)
      .then((response) => {
        setContentDetail(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching form data:", error);
      });
  }, []);

  return (
    <Layout>
      <div
        className="w-full h-[450px] relative bg-cover bg-center flex justify-center items-center"
        style={{
          backgroundImage: `url(${privateGroupImage})`,
          backgroundAttachment: "fixed",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <h1 className="text-4xl text-white z-10 p-4 rounded">
          Private Group Training
        </h1>
      </div>

      <div className="w-[70%] mx-auto my-[6rem] text-lg leading-relaxed">
        <div
          className="text-[#5E6282] font-semibold md:text-[16px]  xl:text-[20px] text-[10px] md:leading-[21.86px] leading-[13.66px] tracking-[1.52px] my-[20px]"
          dangerouslySetInnerHTML={{ __html: contentDetail?.description }}
        ></div>

        <div className="mt-10">
          {!contentDetail ? (
            <p>Loading form...</p>
          ) : submitted ? (
            <div className="p-4 bg-green-100 border border-green-300 rounded">
              Thank you for your inquiry! We will get back to you shortly.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="flex flex-wrap gap-4">
                {contentDetail.form?.map((field, index) => (
                  <div key={index} className="flex-1 min-w-[45%]">
                    <label className="block mb-2 font-medium">
                      {field.label}
                    </label>
                    {field.type === "select" ? (
                      <select
                        name={field.name}
                        required={field.required}
                        onChange={handleChange}
                        className="w-full p-3 border rounded"
                      >
                        <option value="">Select a location</option>
                        {field.options?.map((opt, i) => (
                          <option key={i} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    ) : field.type === "textArea" ? (
                      <textarea
                        name={field.name}
                        required={field.required}
                        placeholder={field.placeholder}
                        onChange={handleChange}
                        rows="6"
                        className="w-full p-3 border rounded"
                      />
                    ) : (
                      <input
                        type={field.type}
                        name={field.name}
                        required={field.required}
                        placeholder={field.placeholder}
                        onChange={handleChange}
                        className="w-full p-3 border rounded"
                      />
                    )}
                  </div>
                ))}
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className="bg-gradient-to-r from-[#B02526] to-[#8B1E1F]  hover:from-[#8B1E1F] hover:to-[#B02526] text-white px-6 py-3 rounded"
                >
                  Submit
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default PrivateGroupTraining;
